import { useUserProfile } from '@/hooks/account/useUser';
import { MoodCheckIn } from './MoodCheckIn';
import type { MoodId } from './moods';

interface MoodStripProps {
  value: MoodId | null;
  onChange: (mood: MoodId) => void;
}

/**
 * The hub's check-in, asked like a person would ask it - by first name
 * when the profile has one. No card around it, and no reply of its own: the
 * answer shows up in "For right now" just below.
 */
/** "How are you feeling, Ada?" - by first name when the profile has one. */
export function moodQuestion(fullName: string | null | undefined): string {
  const first = fullName?.trim().split(/\s+/)[0];
  return first
    ? `How are you feeling, ${first}?`
    : 'How are you feeling today?';
}

export function MoodStrip({ value, onChange }: MoodStripProps) {
  const { data: profile } = useUserProfile();
  return (
    <section aria-labelledby='mood-heading'>
      <MoodCheckIn
        value={value}
        onChange={onChange}
        showResponse={false}
        legend={
          <>
            <h2
              id='mood-heading'
              className='text-xl font-semibold text-foreground'
            >
              {moodQuestion(profile?.full_name)}
            </h2>
            <span className='mt-1 block text-sm text-muted-foreground'>
              Pick the word that fits. Only you can see it.
            </span>
          </>
        }
      />
    </section>
  );
}
